var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"slide"}},[_c('keep-alive',{key:_vm.page_key,attrs:{"include":"archive"}},[_c('router-view')],1)],1),_c('notifications',{attrs:{"group":"alerts"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }